import { render, staticRenderFns } from "./MilkVatReferencesList.vue?vue&type=template&id=9074de8a&"
import script from "./MilkVatReferencesList.vue?vue&type=script&lang=ts&"
export * from "./MilkVatReferencesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports